import React, { useCallback, useContext, useState } from 'react';
import useMemoObject from './useMemoObject';

// MouseContext is the most often updated context and thus separated from the InteractionContext.

const MouseContext = React.createContext<any>({});

export const MouseContextProvider = ({ children }: any) => {
  const [{ mouseX, mouseY }, setMouseXY] = useState<any>({});

  const setMouse = useCallback((mouseX: any, mouseY: any) => {
    setMouseXY({ mouseX, mouseY });
  }, []);

  const value = useMemoObject({ mouseX, mouseY, setMouse });

  return <MouseContext.Provider value={value}>{children}</MouseContext.Provider>;
};
export const useMouseContext = () => useContext(MouseContext); // variable
